import { DivisionRole, User } from '@damofire/data-security';
import { Timestamp } from 'firebase/firestore';
import { PartialOrganization } from './organization.dto';

// Don't add Rep to userValues/values as we don't want it available in the user-divi-role-selector
export const WAREHOUSE_USER_ROLES = {
  MANAGER: 'MANAGER',
  COLLABORATOR: 'COLLABORATOR',
  OBSERVER: 'OBSERVER',
  REPRESENTATIVE: 'REPRESENTATIVE',
  values: () => [WAREHOUSE_USER_ROLES.OBSERVER, WAREHOUSE_USER_ROLES.COLLABORATOR, WAREHOUSE_USER_ROLES.MANAGER],
};

export const APPLICATION_USER_ROLES = {
  tdp: ['GSR_PRODUCTION_ADMIN', 'GSR_PRODUCTION_USER', 'GSR_PRODUCTION_WORKER', 'GSR_PRODUCTION_SU_ADMIN', 'GSR_PRODUCTION_DRAWER', 'GSR_PRODUCTION_SHIPPER'],
  stas: ['GSR_STAX_ADMIN', 'GSR_STAX_VIEWER'],
  repos: ['GSR_REPOS_ADMIN'],
  storage: ['GSR_STORAGE_ADMIN', 'GSR_STORAGE_USER', 'GSR_STORAGE_VIEWER'],
  watson: ['GSR_WATSON_ADMIN', 'GSR_WATSON_USER', 'GSR_WATSON_VIEWER'],
  watsonRep: ['GSR_WATSON_REP', 'GSR_WATSON_EXTERNAL_REP'],
  nexus: ['GSR_NEXUS_SURVEY_ADMIN', 'GSR_NEXUS_SURVEYOR'],
};

export enum USER_STATUS {
  provisioned = 'PROVISIONED',
  active = 'ACTIVE',
  suspended = 'SUSPENDED',
  deprovisioned = 'DEPROVISIONED',
  loading = 'LOADING',
  error = 'ERROR',
  contact = 'CONTACT',
}

export enum RepresentativeType {
  sales = 'SALES',
  engineering = 'ENGINEERING',
}

export interface Representative {
  _id?: string;
  type?: RepresentativeType;
  fullName?: string;
}

export interface ExtendedUser extends User {
  lastLogin?: Timestamp;
  status?: USER_STATUS;
  roles?: string[];
}

export interface LocalizedUserRole {
  role?: string;
  translation?: string;
}

export type UserClaims = RolesClaims & LinksClaims;

export interface RolesClaims {
  roles: string[];
}

export interface LinksClaims {
  manager?: Record<string, DivisionRole>;
  collaborator?: Record<string, DivisionRole>;
  observer?: Record<string, DivisionRole>;
  representative?: Record<string, DivisionRole>;
  administrator?: Record<string, PartialOrganization>;
}

export enum UserPreferencesKey {
  MAIL_DOCUMENTS_DROPPED = 'documents_dropped',
  MAIL_DOCUMENTS_DELETED = 'documents_deleted',
  MAIL_USER_ACTIVATED = 'user_activated',
  MAIL_USER_SUSPENDED = 'user_suspended',
  OFFLINE_WAREHOUSE = 'offline_warehouse',
  REP_ISSUE_EMAIL = 'rep_issue_email',
  SURVEY_CANADIAN_RACK_STYLE = 'survey_canadian_rack_style',
  SYNC_PICTURES_MIN_RISK_LEVEL = 'user_syncPicturesMinRiskLevel',
}

export enum PictureSyncRiskFilter {
  ALL = 'ALL',
  LOW = 'LOW',
  MODERATE = 'MODERATE',
  HIGH = 'HIGH',
  OFFLOAD = 'OFFLOAD',
}
